module.exports = __webpack_public_path__ + "img/電気回路_6_5_5.bfc2b0ad.png";